import { render, staticRenderFns } from "./noDataState.vue?vue&type=template&id=d852fbf4&scoped=true"
import script from "./noDataState.vue?vue&type=script&lang=js"
export * from "./noDataState.vue?vue&type=script&lang=js"
import style0 from "./noDataState.vue?vue&type=style&index=0&id=d852fbf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d852fbf4",
  null
  
)

export default component.exports